import i18n from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'

export async function initializeTranslations (locale: string) {
  await i18n
    .use(resourcesToBackend((lng: string, ns, clb) => {
      import(`./locales/${lng}.json`)
        .then((resources) => clb(null, resources))
        .catch(clb)
    }))
    .init({
      fallbackLng: 'en',
      lng: locale,
      debug: process.env.NODE_ENV === 'development'
    })
}
